export { postLogin } from './login';
export { postRegistration } from './registration';



// WEBPACK FOOTER //
// ./src/actions/auth/index.js